<!--LIGNE SÉPARATRICE EN DÉGRADER DE CHAQUE COTÉ-->
<template>
    <div class="inscriptionTaxeViewer">

        <div class="itemMain">
            <div class="itemSubTitle">{{$t('ins_Taxes')}}</div>
            <div class="itemContain">

                <h6 class="subTitle5">{{$t('tax_Debit')}}</h6>

                <b-row>
                    <b-col :cols="taxColSize.txName">
                        {{getActiveTaxes.nameF}} ({{getActiveTaxes.taxesConfigGL.glFDebit}})
                    </b-col>
                    <b-col align="right" :cols="taxColSize.txAmount">
                        {{$FM(_taxesValue.glFDebit, 2)}}
                    </b-col>
                    <b-col :cols="taxColSize.txName">
                        {{getActiveTaxes.nameP}} ({{getActiveTaxes.taxesConfigGL.glPDebit}})
                    </b-col>
                    <b-col align="right" :cols="taxColSize.txAmount">
                        {{$FM(_taxesValue.glPDebit, 2)}}
                    </b-col>
                </b-row>
                <b-row>
                    <b-col :cols="taxColSize.txName">
                        {{getActiveTaxes.nameF}} {{$t('tax_Incluse')}}  ({{getActiveTaxes.taxesConfigGL.glFDebit}})
                    </b-col>
                    <b-col align="right" :cols="taxColSize.txAmount">
                        {{$FM(_taxesValue.glFIncludeDebit, 2)}}
                    </b-col>
                    <b-col :cols="taxColSize.txName">
                        {{getActiveTaxes.nameP}} {{$t('tax_Incluse')}}  ({{getActiveTaxes.taxesConfigGL.glPDebit}})
                    </b-col>
                    <b-col align="right" :cols="taxColSize.txAmount">
                        {{$FM(_taxesValue.glPIncludeDebit, 2)}}
                    </b-col>
                </b-row>
                <b-row>
                    <b-col :cols="taxColSize.txName">
                        {{$t('tax_TaxeDhebergement')}}  ({{getActiveTaxes.taxesConfigGL.glMotelDebit}})
                    </b-col>
                    <b-col align="right" :cols="taxColSize.txAmount">
                        {{$FM(_taxesValue.glMotelDebit, 2)}}
                    </b-col>
                    <b-col :cols="taxColSize.txName">
                        {{$t('tax_Pneu')}}  ({{getActiveTaxes.taxesConfigGL.glTireDebit}})
                    </b-col>
                    <b-col align="right" :cols="taxColSize.txAmount">
                        {{$FM(_taxesValue.glTireDebit, 2)}}
                    </b-col>
                </b-row>

                <h6 class="subTitle5">{{$t('tax_Credit')}}</h6>

                <b-row>
                    <b-col :cols="taxColSize.txName">
                        {{getActiveTaxes.nameF}} ({{getActiveTaxes.taxesConfigGL.glFCredit}})
                    </b-col>
                    <b-col align="right" :cols="taxColSize.txAmount">
                        {{$FM(_taxesValue.glFCredit, 2)}}
                    </b-col>
                    <b-col :cols="taxColSize.txName">
                        {{getActiveTaxes.nameP}} ({{getActiveTaxes.taxesConfigGL.glPCredit}})
                    </b-col>
                    <b-col align="right" :cols="taxColSize.txAmount">
                        {{$FM(_taxesValue.glPCredit, 2)}}
                    </b-col>
                </b-row>
                <b-row>
                    <b-col :cols="taxColSize.txName">
                        {{getActiveTaxes.nameF}} {{$t('tax_Incluse')}}  ({{getActiveTaxes.taxesConfigGL.glFCredit}})
                    </b-col>
                    <b-col align="right" :cols="taxColSize.txAmount">
                        {{$FM(_taxesValue.glFIncludeCredit, 2)}}
                    </b-col>
                    <b-col :cols="taxColSize.txName">
                        {{getActiveTaxes.nameP}} {{$t('tax_Incluse')}}  ({{getActiveTaxes.taxesConfigGL.glPCredit}})
                    </b-col>
                    <b-col align="right" :cols="taxColSize.txAmount">
                        {{$FM(_taxesValue.glPIncludeCredit, 2)}}
                    </b-col>
                </b-row>
                <b-row>
                    <b-col :cols="taxColSize.txName">
                        {{$t('tax_TaxeDhebergement')}}  ({{getActiveTaxes.taxesConfigGL.glMotelCredit}})
                    </b-col>
                    <b-col align="right" :cols="taxColSize.txAmount">
                        {{$FM(_taxesValue.glMotelCredit, 2)}}
                    </b-col>
                    <b-col :cols="taxColSize.txName">
                        {{$t('tax_Pneu')}}  ({{getActiveTaxes.taxesConfigGL.glTireCredit}})
                    </b-col>
                    <b-col align="right" :cols="taxColSize.txAmount">
                        {{$FM(_taxesValue.glTireCredit, 2)}}
                    </b-col>
                </b-row>
            </div>
        </div>
                        
    </div>
</template>

<script>
import {mapGetters} from 'vuex'

export default{
    name: "inscriptionTaxeViewer",
    props:['taxes'],
    data() {
        return {
            taxColSize: {
                txName: 3,
                txAmount: 3
            },
        }
    },
    methods: {

    },
    computed: {
        ...mapGetters(['getTheme', 'getActiveTaxes', 'getTaxes']),
        _taxesValue: {
            get: function() {return this.taxes},
            set: function(modifiedValue){this.$emit('update:taxes', modifiedValue)}
        },
    }
}

</script>

<style lang="scss" scoped>

</style>